/**
 * RabbitMQ WebSocket URLs
 * Only connect to the configured RabbitMQ WebSocket URL.
 */

declare var process: {
  env: {
    REACT_APP_RABBITMQ_WS_URL?: string;
    REACT_APP_RABBITMQ_VHOST?: string;
    REACT_APP_RABBITMQ_USERNAME?: string;
    REACT_APP_RABBITMQ_PASSWORD?: string;
    [key: string]: string | undefined;
  };
};

const buildWebSocketCandidates = (): string[] => {
  console.log('REACT_APP_RABBITMQ_WS_URL:', process.env.REACT_APP_RABBITMQ_WS_URL);

  /** Only use the configured RabbitMQ WebSocket URL */
  const directUrl = process.env.REACT_APP_RABBITMQ_WS_URL || 'wss://rabbitmq-dev.b8ak.com/ws';

  // Only return the direct URL, no fallbacks to localhost or API URL
  return [directUrl];
};

const WS_URLS = buildWebSocketCandidates();

export const RABBITMQ_CONFIG = {
  WS_URL: WS_URLS[0],
  WS_URLS,
  VHOST: process.env.REACT_APP_RABBITMQ_VHOST || '/',
  USERNAME: process.env.REACT_APP_RABBITMQ_USERNAME || 'frontend_ws',
  PASSWORD: process.env.REACT_APP_RABBITMQ_PASSWORD || 'oKyGSQ5cFgrrcsavuj11s2cN'
};
